import { Component, OnInit, Inject } from '@angular/core';
import { WoundService } from 'src/app/services/wound.service';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { MatTableDataSource } from '@angular/material/table';
import { CommonService } from 'src/app/services/common.service';
import { TemplateExplorerService } from 'src/app/includes/templates/template-explorer/template-explorer.service';
import { CompanyService } from 'src/app/services/Modules/company.service';

@Component({
  selector: 'app-dialogue-add-cpt-code',
  templateUrl: './dialogue-add-cpt-code.component.html',
  styleUrls: ['./dialogue-add-cpt-code.component.css']
})
export class DialogueAddCptCodeComponent implements OnInit {
newCPTmodel : any = {
    conceptId: "",
    code: "",
    clinicianDescriptorId: "",
    title: "",
    description: "",
    end_date: "",
    company_id: null,
    isCptCode: true,     // used in backend api "addNewCPTCode"
    isDuplicateAllowed: false  // used in backend api "addNewCPTCode" 
  };
  place_of_service = [];
  pos_ids = [];
  public current_date = new Date();
  isEmptyCodeDescription = true;
  dataSource: any = new MatTableDataSource([]);
  displayedColumns: string[] = ['Code', 'Description'];
  cpts = [];
  isShowTable = false;
  isCloseDialogue = false;
  pos = [];

  constructor(private toastr: ToastrService,
    private _woundService: WoundService,
    private dialogRef: MatDialogRef<DialogueAddCptCodeComponent>,
    private dialog: MatDialog,
    private commonService: CommonService,
    private companyService: CompanyService,
    @Inject(MAT_DIALOG_DATA) public data: DialogueAddCptCodeComponent) {
      
     }

  ngOnInit(): void {
    this.getPOS();
  }

  getPOS(){
    this.companyService.getAllPOS().subscribe((res: any) => {
      if (res.status == 200) {
        this.pos = res.data;
      } else {
        console.log('something went wrong');
      }
    });
  }
  checkIsEmpty(){
    if (this.newCPTmodel.code.trim().length === 0)
      this.isEmptyCodeDescription = true;
    else if (this.newCPTmodel.description.trim().length === 0)
      this.isEmptyCodeDescription = true;
    else
      this.isEmptyCodeDescription = false;
  
  }

  async handleSubmit(e) {
    let response: any, toastrId;
    this.checkIsEmpty();

    try {
        if (!this.isCloseDialogue) {
        toastrId = this.toastr.info("Adding New Code", "Please Wait...", { disableTimeOut: true });

          if (this.newCPTmodel.end_date)
            this.newCPTmodel.end_date = this.commonService.convertDateToStringforMoment(this.newCPTmodel.end_date, false, false, true);

        this.newCPTmodel.company_id = this.data;
        response = await this._woundService.addNewCPTCode(this.newCPTmodel).toPromise();
        if (response.status == 200) {
          // when jsonData.posID is an array of ids, "isMultiplePos" is set true
          this.updatePOSRelation(this.newCPTmodel.company_id, response.cptcodeData._id, this.place_of_service, true, true);
          this.toastr.clear(toastrId.toastId);
          this.toastr.success("Code Added Succesfully", "Success");
          this.dialogRef.close({ data: response });
        } else {
          this.toastr.clear(toastrId.toastId);
          this.cpts = response.data;
          this.dataSource.data = this.cpts;
          this.isShowTable = true;
          this.checkIsEmpty();

        }
      }
      else
        this.dialogRef.close({ data: response });

    } catch (err) {
      this.toastr.clear(toastrId.toastId);
      this.toastr.error('Something went wrong', 'Error');
    }
  }

  addDuplicateCode(event: any){
    this.newCPTmodel.isDuplicateAllowed = true;
    this.handleSubmit(event);
  }

  closeDialogue(event: any){
    this.isCloseDialogue = true;
    this.handleSubmit(event);
  }


  clearDetails() {
    this.newCPTmodel = {
      conceptId: "",
      code: "",
      clinicianDescriptorId: "",
      title: "",
      description: "",
      company_id: null,
      isCptCode: true,
      isDuplicateAllowed: false,
      end_date: ""
    };
    this.place_of_service = [];
    this.isEmptyCodeDescription = true;
    this.isShowTable = false;

  }

  keyPressAlphanumeric(event) {
    const inp = String.fromCharCode(event.keyCode);

    if (/[a-zA-Z0-9\s/-_-.-]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  async updatePOSRelation(companyId, cptId, posIDs, isCreating: boolean, isMultiplePos = false) {
    this.companyService.updatePOSRelation(companyId, cptId, posIDs, isCreating, isMultiplePos).subscribe((res: any) => {
      if (res.status == 200) {
        this.toastr.success('CPT POS Relation Added!', 'Success');
      } else {
        console.log('something went wrong');
      }
    });
  }

  triggerEvent(value) {
    this.place_of_service = [];
    this.place_of_service = this.pos.filter(pos => this.pos_ids.includes(pos._id));
  }

  addFieldToModel($event) {
    if($event.checked) 
      this.newCPTmodel.use_once_per_admit = $event.checked;
  }

}
